import React, { useState } from "react";
import { Link } from "react-router-dom";
import { toast } from "react-toastify";
import { commonService } from "../Network/services/commonService";

const Footer = () => {
  const [newsletterEmail, setNewsletterEmail] = useState("");
  const [isSubmitting, setIsSubmitting] = useState(false);

  const scrollToTop = () => {
    window.scrollTo({
      top: 0, 
      behavior: 'smooth'
    });
  };

  const handleNewsletterSubmit = async (e) => {
    e.preventDefault();
    
    if (!newsletterEmail || !newsletterEmail.trim()) {
      toast.error("Please enter your email address");
      return;
    }

    const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
    if (!emailRegex.test(newsletterEmail)) {
      toast.error("Please enter a valid email address");
      return;
    }

    setIsSubmitting(true);

    try {
      const payload = new FormData();
      payload.append("email", newsletterEmail.trim());

      const response = await commonService.CommonService("newsletter_subscribe", payload);
      
      if (response && response.status === "success") {
        toast.success("Thank you for subscribing to our newsletter!");
        setNewsletterEmail("");
      } else {
        toast.error(response?.message || "Subscription failed. Please try again.");
      }
    } catch (error) {
      toast.error("Something went wrong. Please try again later.");
    } finally {
      setIsSubmitting(false);
    }
  };

  return (
    <div>
      <section className="popup-footer">
        <footer className="landing-footer" data-animate id="footer">
        <div className="landing-page-container">
          <div className="footer-content">
            <div className="footer-logo">
              <div className="footer-logo-icon">
                <img src="/assets/images/NEW_FWS_FOOTER_LOGO.svg" alt="GigFWS Logo" style={{ transform: 'scale(1.1)', transition: 'transform 0.2s ease' }}/>
              </div>
            </div>
            
            <div className="footer-nav">
              <Link to="/about" className="footer-nav-link">About Us</Link>
              <Link to="/terms-and-conditions" className="footer-nav-link">Terms & Condition</Link>
              <Link to="/privacy-policy" className="footer-nav-link">Privacy Policy</Link>
              <Link to="/pricing-and-refund-policy" className="footer-nav-link">Pricing & Refund Policy</Link>
            </div>
            
            <div className="footer-main">
              <div className="footer-left">
                <div className="footer-contact">
                  <a href="mailto:support@gigfws.com" className="footer-contact-item" style={{ textDecoration: 'none' }}>
                    <img src="/assets/images/EmailIcon.svg" alt="Email" className="contact-icon" />
                    <p>support@gigfws.com</p>
                  </a>
                  <a href="tel:+919620400919" className="footer-contact-item" style={{ textDecoration: 'none' }}>
                    <img src="/assets/images/MobileIcon.svg" alt="Phone" className="contact-icon" />
                    <p>+91-9620400919</p>
                  </a>
                </div>
                <div className="landing-social-icons">
                  <a href="https://www.facebook.com/GIGFWS/" target="_blank" rel="noopener noreferrer" aria-label="Facebook">
                    <img src="/assets/images/FacebookSocialIcon.svg" alt="Facebook" />
                  </a>
                  <a href="https://www.linkedin.com/company/gigfws" target="_blank" rel="noopener noreferrer" aria-label="LinkedIn">
                    <img src="/assets/images/LinkedInSocialIcon.svg" alt="LinkedIn" />
                  </a>
                  <a href="https://twitter.com/gigfws" target="_blank" rel="noopener noreferrer" aria-label="Twitter">
                    <img src="/assets/images/TwitterSocialIcon.svg" alt="Twitter" />
                  </a>
                  <a href="https://www.youtube.com/channel/UCilBzr_1gIy8pF0pJFq2nsQ/featured" target="_blank" rel="noopener noreferrer" aria-label="YouTube">
                    <img src="/assets/images/YouTubeSocialIcon.svg" alt="YouTube" />
                  </a>
                </div>
              </div>
              
              
              <div className="footer-copyright">
                <p className="copyright-text">© 2025 GigFWS. All rights reserved.</p>
              </div>
            </div>
          </div>
        </div>
        </footer>
      </section>
      <div className="go-top" onClick={scrollToTop}>
        <i className="flaticon-up-arrow" />
      </div>
    </div>
  );
};

export default Footer;
